<template>
  <div class="box">
    <div id="app-home">
      <div class="tree">
        <el-input
          class="input"
          placeholder="搜索关键字"
          v-model="filterText"
          prefix-icon="el-icon-search"
        >
        </el-input>
        <div class="treeList">
          <el-tree
            :data="treeList"
            :show-checkbox="true"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            ref="tree"
            @check="checkTree"
            :default-expanded-keys="nodeList"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <div>
                <img
                  v-if="data.child && data.child.length > 0"
                  src="@/assets/depament1.svg"
                  alt=""
                />
                <span>{{ data.departmentName }}</span>
              </div>
              <span v-if="data.child && data.child.length > 0">
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="submit">
        <el-button class="button" @click="query">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
// import moment from "moment";
// import { getToken } from "@/utils/cookie";
export default {
  name: "home",
  data() {
    return {
      treeList: [],
      filterText: "",
      infoList: {
        id: "",
        deptName: "",
      },
      defaultProps: {
        children: "child",
        label: "departmentName",
      },
      list: [],
      nodeList: [],
    };
  },
  created() {},
  mounted() {
    this.getList();
    const str = this.$route.query.id.split(",");
    str &&
      str.forEach((item) => {
        this.nodeList.push(Number(item));
      });
    if (str && str.length > 0) {
      // this.nodeList.push(id);
      this.$refs.tree.setCheckedKeys(this.nodeList, true);
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 获取部门列表的方法
    getList() {
      api.findListByName({ departmentName: this.filterText }).then((data) => {
        this.treeList = data.data;
      });
    },
    // 获取父节点的方法
    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);
      return checkedNodes;
    },
    // 选中节点的方法
    checkTree() {
      const nodes = this.$refs.tree.getCheckedNodes(true);
      // if (nodes.length > 1) {
      //   this.$message({
      //     type: "warning", // success error warning
      //     message: "只能选择一个部门",
      //     duration: 1000,
      //   });
      //   this.$refs.tree.setCurrentKey(data.id);
      //   this.$refs.tree.setCheckedKeys([data.id]);
      // }
      this.list = nodes;
    },
    // 过滤节点的方法
    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },
    // 确认选择部门
    query() {
      let res = this.getSimpleCheckedNodes(this.$refs.tree.store);
      localStorage.setItem("depament", JSON.stringify(res));
      // this.$bus.$emit("depament", res);
      this.$store.commit("changeInfoDepament", res);
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}
.box {
  width: 100%;
  display: flex;
  justify-content: center;
}
#app-home {
  font-size: 16px * $zoom;
  position: relative;
  background: rgba(247, 249, 250, 1);
  min-height: 100vh;
  //   padding: 20px;
}
.tree {
  background: #ffffff;
  height: 1100px;
  .input {
    margin: 20px 0;
    ::v-deep .el-input__inner {
      width: 90%;
      height: 70px;
      margin-left: 5%;
      padding-left: 70px;
      background: rgba(235, 237, 242, 1);
      border: none;
    }
    ::v-deep .el-input__icon {
      margin-left: 40px;
      font-size: 34px;
      margin-top: 3px;
    }
  }
  .treeList {
    height: 940px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  ::v-deep .el-checkbox {
    padding-left: 20px;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    display: none;
  }
  ::v-deep .el-tree-node__content {
    display: flex;
    height: 100px !important;
    padding: 0 20px;
    border-bottom: 1px solid #f6f6f6;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    div {
      margin-left: 15px;
      display: flex;
      align-items: center;
      span {
        font-size: 32px;
        margin-left: 20px;
      }
    }
  }
  .el-icon-arrow-right {
    font-size: 32px;
    color: #ccc;
  }
}
.submit {
  position: absolute;
  bottom: 100px;
  width: 80%;

  .button {
    width: 100%;
    background: rgba(78, 162, 124, 1);
    color: #fff;
    height: 80px;
    font-size: 30px;
    padding-top: 15px;
    border-radius: 20px;
    margin-left: 12.5%;
  }
}

::v-deep {
  .el-checkbox__inner {
    width: 16px * $zoom;
    height: 16px * $zoom;
  }
  .el-checkbox__inner::after {
    height: 8px * $zoom;
    top: 2.5px * $zoom;
    left: 6px * $zoom;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    top: 6px * $zoom;
  }
}
</style>
